import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import {
  ArrowPosition,
  BaseTooltipComponent,
  ButtonComponent,
  IconButtonComponent,
  BadgeComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.less'],
  standalone: true,
  imports: [NgClass, BadgeComponent, IconButtonComponent, ButtonComponent, TranslatePipe],
})
export class FeatureTooltipComponent extends BaseTooltipComponent {
  @Input() public isNew: boolean;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public learnMore?: string;
  @Input() public learnMoreCopy?: string;
  @Input() public arrowPosition: ArrowPosition;

  @Output() public learnMoreClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  public ngOnChanges(): void {
    this.updateArrow(this.arrowPosition);
  }
}
